export const iconA = () => {
  const baseSvg = `<svg style="font-size: 42px;" stroke="#da1414" fill="#da1414" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 32c-88.004 0-160 70.557-160 156.801C96 306.4 256 480 256 480s160-173.6 160-291.199C416 102.557 344.004 32 256 32zm0 212.801c-31.996 0-57.144-24.645-57.144-56 0-31.357 25.147-56 57.144-56s57.144 24.643 57.144 56c0 31.355-25.148 56-57.144 56z"></path></svg>`;

  const encodedSvg = encodeURIComponent(baseSvg);

  return {
    url: `data:image/svg+xml;utf8,${encodedSvg}`,
  };
};
